<template>
  <!--Logo start-->
  <div class="logo-main">
    <img class="w-100" alt="scuba world divers logo" src="https://scubaworlddivers.com/images/svg/main-logo.svg" />
  </div>
  <!--Logo End-->
</template>
